<article class="content">
  <h1>{{ title$ | async }}</h1>
  <p>
    {{message$ | async}}
  </p>
</article>
